(function() {

    "use strict";

    /**
     * Transforms a segment array.
     *
     *     var converter = new Ofcs.SegmentsTransformer();
     *
     * @constructor
     */
    Ofcs.SegmentsTransformer = function() {
        // nothing to do in constructor
    };

    Ofcs.SegmentsTransformer.prototype = {

        /**
         * @param {Array} segments multidimensional array
         * @param {Number} rotation
         *
         * @returns {Array} transformed segments
         */
        rotate: function(segments, rotation) {

            var matrix = new Ofcs.Matrix();

            matrix.rotate(rotation);

            return this.transform(segments, matrix);
        },

        /**
         * @param {Array} segments multidimensional array
         * @param {Ofcs.Matrix} matrix transformation matrix
         *
         * @returns {Array} transformed segments
         */
        transform: function(segments, matrix) {
            var transformed = [], i, j;

            for (i = 0; i < segments.length; i += 1) {
                transformed[i] = [];

                for (j = 0; j < segments[i].length; j += 1) {
                    transformed[i][j] = this._transformSegment(segments[i][j], matrix);
                }
            }

            return transformed;
        },

        /**
         *
         * @param {Array} segment
         * @param {Ofcs.Matrix} matrix
         *
         * @returns {Array} transformed segment
         */
        _transformSegment: function(segment, matrix) {

            var x = segment[1],
                y = segment[2];

            this._assertSegmentIsMoveOrLine(segment);

            return [
                segment[0],
                matrix.x(x, y),
                matrix.y(x, y)
            ];
        },

        /**
         * Assert that segment is a line 'L'.
         *
         * @param {Array} segment
         */
        _assertSegmentIsMoveOrLine: function (segment) {
            if (segment.length && segment[0] !== 'L'&& segment[0] !== 'M') {
                throw 'Expecting move ("M") or line ("L"), found: "' + segment[0] + '"';
            }
        }

    };

}());
